"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import { ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import UserSettingsClassification from "@/components/user/settings/UserSettingsClassification";
import UserSettingsSave from "@/components/user/settings/UserSettingsSave";
import type { ApiCreateOrUpdateProfileRequest } from "@/entities/IProfile";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { ApiProfileClassification } from "@/generated/models/ApiProfileClassification";
import { commonApiPost } from "@/services/api/common-api";
import { useMutation } from "@tanstack/react-query";
import { useContext, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useClickAway, useKeyPressEvent } from "react-use";
export default function UserPageHeaderEditClassification(t0) {
  const $ = _c(39);
  const {
    profile,
    onClose
  } = t0;
  const modalRef = useRef(null);
  useClickAway(modalRef, onClose);
  useKeyPressEvent("Escape", onClose);
  const {
    setToast,
    requestAuth
  } = useContext(AuthContext);
  const {
    onProfileEdit
  } = useContext(ReactQueryWrapperContext);
  const [classification, setClassification] = useState(profile.classification ?? ApiProfileClassification.Pseudonym);
  const [haveChanges, setHaveChanges] = useState(false);
  let t1;
  if ($[0] !== classification || $[1] !== profile.classification) {
    t1 = () => {
      setHaveChanges(classification !== profile.classification);
    };
    $[0] = classification;
    $[1] = profile.classification;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== classification) {
    t2 = [classification];
    $[3] = classification;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  useEffect(t1, t2);
  const [mutating, setMutating] = useState(false);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = async body => {
      setMutating(true);
      return await commonApiPost({
        endpoint: "profiles",
        body
      });
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onClose || $[7] !== onProfileEdit || $[8] !== setToast) {
    t4 = updatedProfile => {
      setToast({
        message: "Profile updated.",
        type: "success"
      });
      onProfileEdit({
        profile: updatedProfile,
        previousProfile: null
      });
      onClose();
    };
    $[6] = onClose;
    $[7] = onProfileEdit;
    $[8] = setToast;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== setToast) {
    t5 = error => {
      setToast({
        message: error as string,
        type: "error"
      });
    };
    $[10] = setToast;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setMutating(false);
    };
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t5) {
    t7 = {
      mutationFn: t3,
      onSuccess: t4,
      onError: t5,
      onSettled: t6
    };
    $[13] = t4;
    $[14] = t5;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const updateUser = useMutation(t7);
  let t8;
  if ($[16] !== classification || $[17] !== profile.banner1 || $[18] !== profile.banner2 || $[19] !== profile.handle || $[20] !== profile.pfp || $[21] !== requestAuth || $[22] !== setToast || $[23] !== updateUser) {
    t8 = async e => {
      e.preventDefault();
      if (!profile.handle) {
        return;
      }
      const {
        success
      } = await requestAuth();
      if (!success) {
        setToast({
          message: "You must be logged in to save settings",
          type: "error"
        });
        return;
      }
      const body_0 = {
        handle: profile.handle,
        classification
      };
      if (profile.banner1) {
        body_0.banner_1 = profile.banner1;
      }
      if (profile.banner2) {
        body_0.banner_2 = profile.banner2;
      }
      if (profile.pfp) {
        body_0.pfp_url = profile.pfp;
      }
      await updateUser.mutateAsync(body_0);
    };
    $[16] = classification;
    $[17] = profile.banner1;
    $[18] = profile.banner2;
    $[19] = profile.handle;
    $[20] = profile.pfp;
    $[21] = requestAuth;
    $[22] = setToast;
    $[23] = updateUser;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  const onSubmit = t8;
  if (typeof document === "undefined") {
    return null;
  }
  let t9;
  if ($[25] !== onClose) {
    t9 = <button type="button" aria-label="Close edit classification modal" className="tw-absolute tw-inset-0 tw-bg-gray-600 tw-bg-opacity-50 tw-backdrop-blur-sm tw-cursor-pointer tw-border-none tw-p-0" onClick={onClose} />;
    $[25] = onClose;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] !== classification) {
    t10 = <UserSettingsClassification selected={classification} onSelect={setClassification} />;
    $[27] = classification;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  const t11 = !haveChanges;
  let t12;
  if ($[29] !== mutating || $[30] !== t11) {
    t12 = <UserSettingsSave loading={mutating} disabled={t11} />;
    $[29] = mutating;
    $[30] = t11;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== onSubmit || $[33] !== t10 || $[34] !== t12) {
    t13 = <div className="tw-relative tw-flex tw-min-h-full tw-w-full tw-overflow-y-auto tw-items-center tw-justify-center tw-p-2 lg:tw-p-4"><div ref={modalRef} className="tw-w-full tw-transform tw-rounded-xl tw-bg-iron-950 tw-text-left tw-shadow-xl tw-transition-all tw-duration-500 tw-p-6 lg:tw-p-8 md:tw-max-w-xl"><form onSubmit={onSubmit} className="tw-flex tw-flex-col tw-gap-y-6">{t10}{t12}</form></div></div>;
    $[32] = onSubmit;
    $[33] = t10;
    $[34] = t12;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== t13 || $[37] !== t9) {
    t14 = createPortal(<div className="tailwind-scope tw-fixed tw-inset-0 tw-z-[1100] tw-cursor-default">{t9}{t13}</div>, document.body);
    $[36] = t13;
    $[37] = t9;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  return t14;
}